import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useSkills } from "routes/@lib/skills"
import { updateTailoredAuditRejection } from "./controller/update-tailored-audit-rejection"
import { createTailoredAuditRejection } from "./controller/create-tailored-audit-rejection"
import { formatCreateTailoredAudit } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/lib/format-create-tailored-audit"
import { EditAuditReason } from "routes/regime/extension-edit/plugins/tailored-schedule-auditing/edit-audit-reason"

export function EditRejection() {
    const {
        rejection,
        setRejection,
        tailoringReferenceId,
        schedule,
        scheduleItem,
        originalTask,
        tailoredTask,
        tailoringAudit,
    } = useBoundContext()

    const [skills] = useSkills()

    return (
        <EditAuditReason
            value={rejection}
            setValue={setRejection}
            label="Add rejection"
            tailoringAudit={tailoringAudit}
            hasExistingReason={Boolean(tailoringAudit?.payload?.rejection?.reason)}
            dataCy="edit-rejection-text-field"
            onBuildAudit={createAudit}
            onUpdateExisting={updateTailoredAuditRejection}
            onCreate={createTailoredAuditRejection}
            type="rejection"
        />
    )

    function createAudit(reason) {
        const audit = formatCreateTailoredAudit({
            originalTask,
            tailoredTask,
            tailoringReferenceId,
            schedule,
            scheduleItem,
            reason: "",
            skills,
        })
        audit.rejection = { reason }
        return audit
    }
}
